/* 评选接口 */

import { GET, POST, download, uploading, GETNEW, POSTNEW, EXPORTNEW, POSTFormDataNEW, uploadingImg } from '@/request/http'

// 在创建评选的时候获取创建时的所有类型
export const getCreateAeAllType = p => POST('/studentgrowthfiles/commonType/createrRule', p)

// 查询创建规则第四步优秀毕业生评选列表
export const getCreateAeRule = p => POST('/studentgrowthfiles/commonTypeConfig/queryCommonTypeConfigInfoByCode', p)

// 学生信息导入模板下载
export const studentScoreTemplateDownload = p => EXPORTNEW('/studentgrowthfiles/outstandingGraduates/studentTemplate', p)

// 学生成绩信息导入
export const studentScoreToLead = p => POSTFormDataNEW('/studentgrowthfiles/outstandingGraduates/importExport', p)

// 创建评选数据时查询导入的学生成绩信息
export const toLeadStudentScoreSearch = p => POST('/studentgrowthfiles/outstandingGraduates/page/queryStudentAchievement', p)

// 根据评选规则获取各学院的总人数
export const getEligibilityStudentInfo = p => POST('/studentgrowthfiles/outstandingGraduates/queryGraduateSelectionQuota', p)

// 保存新创建的评选数据
export const saveCreateAeData = p => POSTNEW('/studentgrowthfiles/outstandingGraduates/createrRule', p)

// 获取所建的所有评选 （学工处使用）
export const appraiseElectGetTableData = p => POST('/studentgrowthfiles/outstandingGraduates/page/queryCreaterRule', p)

// 获取所建的所有评选 （学院使用）
export const appraiseElecInstitutetGetTableData = p => POSTNEW('/studentgrowthfiles/outstandingGraduates/page/queryFacultyList', p)

// 获取所建的所有评选 （辅导员使用）
export const appraiseElecInstructorGetTableData = p => POST('/studentgrowthfiles/outstandingGraduates/page/queryCreaterRule', p)

// 点击编辑回显创建的评选数据
export const idGetAeData = p => POSTNEW('/studentgrowthfiles/outstandingGraduates/queryCreateInfo', p)

// 完成评选 （学工处使用）
export const appraiseElectComplete = p => GET('/studentgrowthfiles/outstandingGraduates/updateCreaterRuleStatus', p)

// 上传图片
export const ImageUploadAe = p => uploadingImg('/basic/aliyun-oos/upload-image/appraise-elct', p, 5)

// 上传测评结果
export const uploadAeResult = p => POSTNEW('/studentgrowthfiles/outstandingGraduates/reportEvaluate', p, 5)

// 评选（学院）点击查看名单，在查看名单内获取当前学院的评选名单
export const instituteToGetAeList = p => POST('/studentgrowthfiles/outstandingGraduates/page/queryFacultyNameList', p, 5)

// 评选（学生处）点击详情，获取所有学院的评选结果
export const officeToGetAeDetail = p => POSTNEW('/studentgrowthfiles/outstandingGraduates/page/queryCreaterRuleDetails', p, 5)

// 评选（学工处）点击查看名单，在查看名单内获取当前学院的评选名单
export const officeToGetAeList = p => POST('/studentgrowthfiles/outstandingGraduates/page/queryCreaterRuleNameList', p, 5)

// 评选（学工处）点击查看公示照片
export const checkSelectionResults = p => GETNEW('/studentgrowthfiles/outstandingGraduates/queryPublicityPhotoById', p, 5)

// 公示所有学院数据
export const publicityAeData = p => POST('', p, 5)

// 导出所有评选学生数据
export const exportAllAeStudent = p => EXPORTNEW('/studentgrowthfiles/outstandingGraduates/exportAllInfo', p, 5)

// 根据一二等奖学金类型来获取相对应的学生数据（辅导员）
export const instructorGetAeStudentList = p => POSTNEW('/studentgrowthfiles/outstandingGraduates/page/queryCounselorDetails', p, 5)

// 辅导员撤销评选数据
export const instructorRevocation = p => GETNEW('/studentgrowthfiles/outstandingGraduates/deleteApplyInfo', p, 5)

// 辅导员申请评选保存
export const instructorSaveAeData = p => POST('/studentgrowthfiles/outstandingGraduates/saveSelectionApplyInfo', p, 5)

// 学院上报评选数据时获取table数据
export const getCurrentInstructorAllSuccessStud = p => POSTNEW('/studentgrowthfiles/outstandingGraduates/queryReportEvaluate', p, 5)


// 一键下载审批单获取所有学生审核id
export const aeDownLoadAuthorizationZipId = p => GETNEW('/studentgrowthfiles/outstandingGraduates/getApplyCodeList', p, 5)

// 通过审批编号生成pdf辅导员
export const aeInstructorDownLoadAuthorizationZip = p => GETNEW('/approval/print/{approvalNo}/pdf', p, 5)

// 下载审批单
export const aeDownLoadAuthorizationZip = p => EXPORTNEW('/approval/download/zip', p, 5)
export const aeDownLoadAuthorization = p => EXPORTNEW('/studentgrowthfiles/outstandingGraduates/queryApplyNoList', p, 5)

// 下载公示照片
export const aedownloadAuthorizationPhoto = p => EXPORTNEW('/studentgrowthfiles/outstandingGraduates/downLoadPhoto', p, 5)

// 辅导员申请获取学生数据
export const instructorGetAeStudentData = p => POST('/studentgrowthfiles/outstandingGraduates/querySelectionApplyInfo', p, 5)

// 学工删除评选数据
export const delAedata = p => GETNEW('/studentgrowthfiles/outstandingGraduates/deleteInfo', p, 5)

// 修改名次
export const changeRanking = p => POST('/studentgrowthfiles/outstandingGraduates/updateAchievementRanking', p, 5)

// 统计信息查询
export const getStatisticalInformation = p => POST('/studentgrowthfiles/outstandingGraduates/getStatisticsInfo', p, 5)

// 优秀班集体查询学生
export const getStudents = p => POSTNEW('/studentgrowthfiles/outstandingGraduates/getStudentInfoByNo' , p, 4);

// 下载综合成绩
export const aedownloadComprehensiveScores = p => EXPORTNEW('/studentgrowthfiles/outstandingGraduates/downLoadSchoolReport' , p, 4);

// 上传综合成绩
export const aeuploadComprehensiveScores = p => POSTNEW('/studentgrowthfiles/outstandingGraduates/saveSchoolReportAddress' , p, 4);

// 下载成绩单
export const aedownloadTranscripts = p => EXPORTNEW('/studentgrowthfiles/outstandingGraduates/exportStudentAchievementInfo' , p, 4);


// WEBPACK FOOTER //
// ./src/api/modules/appraiseElect.js